<lib-filtered-table
  [tableId]="'in-progress'"
  [tableTitle]="'my_organization_screen_tab_table_title' | transloco"
  [insights]="insights()"
  [dataSource]="dataSource()"
  [meta]="meta()"
  [columns]="columns()"
  [isLoadingData]="isLoading()"
  [tableFilterTabs]="tableFilterTabs()"
  [(payload)]="payload"
  [tableColumnTemplates]="
    [
      { template: number, identifier: COLUMN_IDENTIFIERS.NUMBER },
      { template: id, identifier: COLUMN_IDENTIFIERS.ID },
      { template: name, identifier: COLUMN_IDENTIFIERS.NAME },
      { template: creation_date, identifier: COLUMN_IDENTIFIERS.CREATION_DATE },
      { template: creator, identifier: COLUMN_IDENTIFIERS.CREATOR },
      { template: sla, identifier: COLUMN_IDENTIFIERS.SLA },
      {
        template: remaining_time,
        identifier: COLUMN_IDENTIFIERS.REMAINING_TIME,
      },
      {
        template: request_subject,
        identifier: COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
      },
      { template: project, identifier: COLUMN_IDENTIFIERS.PROJECT },
      { template: current_step, identifier: COLUMN_IDENTIFIERS.CURRENT_STEP },
      { template: assignee, identifier: COLUMN_IDENTIFIERS.ASSIGNEES },
      {
        template: related_requests,
        identifier: COLUMN_IDENTIFIERS.RELATED_REQUESTS,
      },
      { template: action, identifier: COLUMN_IDENTIFIERS.ACTION },
    ]
      | filterTableColByFeatFlag
        : showRelatedRequestsColumn()
        : COLUMN_IDENTIFIERS.RELATED_REQUESTS
  "
  [filterOptions]="filterOptions"
  [filterMapping]="filterMapping"
  [isTableExportable]="false"
  [searchPlaceholder]="'my_organization_screen_search_input_placeholder'"
  [applyOnStreamChanges]="checkReturnedObservable"
  (streamSucceeds)="handleInProgressRequestsSuccess($event)"
  (handleApiCall)="handleApiCall()" />

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #id let-row>
  {{ row.step.flow.request_id }}
</ng-template>

<ng-template #name let-row>
  {{ row.step.flow.name }}
</ng-template>

<ng-template #creation_date let-row>
  <span dir="ltr">
    {{ row.step.flow?.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
  </span>
</ng-template>

<ng-template #creator let-row>
  <lib-request-creator [creator]="row.step.flow.creator" />
</ng-template>

<ng-template #project let-row>
  @if (row.step.flow?.project?.name) {
    <a
      [routerLink]="['/projects' | tenantPath, row.step.flow.project.id]"
      class="flex items-center gap-md cursor-pointer text-neutral-900 hover:!underline hover:text-primary-500">
      <lib-avatar
        [size]="'list'"
        [img]="row.step.flow.project?.image?.url"
        [fullName]="row.step.flow?.project?.name"
        borderRadius="rounded-full" />
      <span class="text-xs font-medium">
        {{ row.step.flow?.project?.name | truncate }}
      </span>
    </a>
  }
</ng-template>

<ng-template #current_step let-row>
  {{ row.step.name }}
</ng-template>

<ng-template #sla let-row>
  <div class="w-[90%]">
    <div class="flex">
      <span
        libSla
        [clockTemplate]="
          row.step.state.value === stepStatusEnum.ON_HOLD
            ? onHoldClockTemplate
            : clockTemplate
        "
        [sla]="row.step.due_date"
        dir="ltr">
        {{ row.step.due_date | date: 'dd-MMM-yyyy hh:mm a' }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #remaining_time let-row>
  {{ row.step.remaining_sla }}
</ng-template>

<ng-template #request_subject let-row>
  <span
    class="request-subject-width"
    libTrimTooltip
    placement="top"
    [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top request-subject-tooltip'"
    [trimLength]="20"
    [fullText]="row.step.flow.request_subject">
  </span>
</ng-template>

<ng-template #assignee let-row>
  @if (row.data) {
    <span
      libTrimTooltip
      placement="top"
      [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top'"
      [trimLength]="20"
      [fullText]="row.data.name || row.data.label">
    </span>
  }
</ng-template>

<ng-template #related_requests let-row>
  <lib-related-requests-dropdown
    [childFlows]="row.step.flow.child_flows"
    [viewDetailsRouterLink]="getRelatedRequestViewLink" />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'in-progress'"
    [menuItems]="row.actionList"
    (itemClick)="actionListItemClick($event, row)" />
</ng-template>

<ng-template #clockTemplate let-isOverdue>
  <lib-clock-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>

<ng-template #onHoldClockTemplate let-isOverdue>
  <lib-hold-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>
